import React from 'react';
import { GLOBAL_COLORS, useCredential } from '../../../hooks';
import { Link } from 'react-router-dom';
import { credentialImageURL } from '../../../hooks/helpers';
import { useTranslation } from 'react-i18next';
import './SingleCredentialDetailedView.css';

const SingleCredentialDetailedView = ({ credentialID }) => {
  const [credentialData, credentialDataLoaded] = useCredential(credentialID);
  const { t } = useTranslation('library');

  const downloadCertificate = () => {
    const certificateElement = document.querySelector('.certificate_cont');
    certificateElement.classList.add('printable');
    window.print();
    certificateElement.classList.remove('printable');
  };

  return (
    <div className="panels">
      {credentialDataLoaded && (
        <div className="certificate_cont">
          <div className="cred_user_div" style={{ display: 'none' }}></div>
          <div className="div-block-152">
            <div className="div-block-154" data-testid="credentialRender">
              <img
                alt=""
                className="image-74"
                loading="lazy"
                sizes="(max-width: 479px) 100vw, (max-width: 991px) 230px, 272px"
                src={credentialImageURL(credentialData)}
                onError={(e) => {
                  e.currentTarget.src = '/images/default_badge.png';
                }}
              />

              {credentialData?.credentialDetails?.metadata?.type && (
                <div>
                  <div className="text-block-97">
                    <span className="text-span-4">{t('Type')}:</span>
                    {credentialData.credentialDetails.metadata.type}
                  </div>
                  <div className="cr_line"></div>
                </div>
              )}

              {credentialData?.credentialDetails?.metadata?.level && (
                <div>
                  <div className="text-block-97">
                    <span className="text-span-4">{t('Level')}:</span>{' '}
                    {credentialData.credentialDetails.metadata.level}
                  </div>
                  <div className="cr_line"></div>
                </div>
              )}

              {credentialData?.credentialDetails?.metadata?.price && (
                <div>
                  <div className="text-block-97">
                    <span className="text-span-4">{t('Time')}:</span>
                    {credentialData.credentialDetails.metadata.price}
                  </div>
                  <div className="cr_line"></div>
                </div>
              )}

              {credentialData?.credentialDetails?.metadata?.time && (
                <div>
                  <div className="text-block-97">
                    <span className="text-span-4">{t('Cost')}:</span>{' '}
                    {credentialData.credentialDetails.metadata.time}
                  </div>
                </div>
              )}
            </div>
            <div className="div-block-153">
              <div className="text-block-98 cr_name">
                {credentialData?.recipient?.name}
              </div>
              <div className="div-block-156">
                <div className="text-block-99">
                  {t('Issued by')}{' '}
                  {credentialData?.credentialDetails?.issuerDetails.name}
                </div>
                <div className="text-block-100">
                  {t('A completion credential')}
                  {credentialData?.course?.name && (
                    <> for {credentialData.course.name}</>
                  )}{' '}
                  {t('was issued to')} {credentialData?.recipient?.name}{' '}
                  {t('on')}{' '}
                  {new Date(credentialData?.issuedOn).toLocaleString('en-US', {
                    month: 'long',
                  })}{' '}
                  {new Date(credentialData?.issuedOn).getDate()},{' '}
                  {new Date(credentialData?.issuedOn).getFullYear()}.
                </div>
              </div>

              <div className="div-block-156">
                {credentialData?.credentialDetails?.metadata && (
                  <>
                    <div className="text-block-99">{t('Skills')}</div>
                    <div className="div-block-155">
                      {credentialData?.credentialDetails?.metadata?.skills.map(
                        (skill, i) => (
                          <div key={i} className="div-block-16 cr_skill">
                            <div className="text-block-12">{skill}</div>
                          </div>
                        )
                      )}
                    </div>
                  </>
                )}
              </div>

              {/*TODO : add earning criteria scenario*/}
              {credentialData?.course?.name && (
                <div className="div-block-156">
                  <div className="text-block-99">{t('Course')}</div>
                  <Link
                    className="link-block-8 w-inline-block"
                    to={`/courses/${credentialData?.course?.course_id}`}
                  >
                    <img
                      alt=""
                      className="image-75"
                      loading="lazy"
                      src="/images/document_1document.png"
                    />
                    <div className="text-block-101">
                      {credentialData?.course?.name}
                    </div>
                  </Link>
                </div>
              )}

              <div className="div-block-156">
                <div className="text-block-99">{t('Issued on')}</div>
                <div className="text-block-101 issue-date">
                  {new Date(credentialData?.issuedOn).toLocaleString('en-US', {
                    month: 'long',
                  })}{' '}
                  {new Date(credentialData?.issuedOn).getDate()} ,{' '}
                  {new Date(credentialData?.issuedOn).getFullYear()}
                </div>
              </div>
            </div>
          </div>
          <div
            className="div-block-475 add_skill certificate_download_button"
            onClick={downloadCertificate}
            style={{ minWidth: '200px', marginTop: '20px' }}
          >
            <img
              src="/images/download.png"
              loading="lazy"
              alt=""
              className="image-152 add_sk"
            />
            <div className="text-block-284 add_skill_text">
              {t('Download Certificate')}
            </div>
          </div>
        </div>
      )}

      {/*<CiShare2 color={GLOBAL_COLORS.icon_color} className="image-141"*/}
      {/*          style={{ width: '50px', height: '50px' }} />*/}
    </div>
  );
};

export { SingleCredentialDetailedView };
